import { getCategoryPhoto } from 'shared/helpers/dispensaries';
import type { DispensaryMenuCategory } from 'src/dispensary/hooks/use-dispensary-categories';
import type { Dispensaries, SpecialMenuCard } from 'src/gql/graphql';
import type { CategoryTile } from 'src/theme/provider/commerce-components/category-tiles-contract';

import { categoryMatchesKey } from 'components/specials-category-cards/match-category';

export function selectSpecialsCategories(
  specials: SpecialMenuCard[],
  dispensaryCategories: DispensaryMenuCategory[]
): DispensaryMenuCategory[] {
  const specialCategoryNames = new Set<string>();

  specials.forEach((special) => {
    (special.applicableCategories ?? []).forEach((applicableCategory) => {
      if (applicableCategory.category) {
        specialCategoryNames.add(applicableCategory.category);
      }
    });
  });

  return dispensaryCategories.filter((category) =>
    [...specialCategoryNames].some((specialCategoryName) => categoryMatchesKey(specialCategoryName, category.key))
  );
}

export function getSpecialsCategoryHref(
  dispensaryRootUrl: string,
  dispensaryCName: string,
  categoryKey: string
): string {
  return `/${dispensaryRootUrl}/${dispensaryCName}/specials/category/${categoryKey}`;
}

export function mapSpecialsCategoryTile(
  category: DispensaryMenuCategory,
  dispensary: Dispensaries,
  dispensaryRootUrl: string
): CategoryTile {
  return {
    id: category.key,
    cname: category.slug ?? category.key,
    name: category.label,
    isOutlet: category.isOutlet,
    image: category.cardImage ?? getCategoryPhoto(dispensary, category),
    href: getSpecialsCategoryHref(dispensaryRootUrl, dispensary.cName ?? '', category.key),
  };
}
